import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface LoaderState {
    isLoading:boolean,
    isPublish:boolean
}

const initialState:LoaderState = {
    isLoading: false,
    isPublish: false
}

interface ToggleLoaderPayloader{
    isLoading:boolean
}

interface TogglePublish{
    isPublish:boolean
}

const loaderSlice = createSlice({
    name:'loader slice',
    initialState: initialState,
    reducers:{
        toggleLoader:(state,action:PayloadAction<ToggleLoaderPayloader>)=>{
            return{
                ...state,
                isLoading: action.payload.isLoading
            }
        },
        togglePublish:(state,action:PayloadAction<TogglePublish>)=>{
            return{
                ...state,
                isPublish: action.payload.isPublish
            }
        }
    }
});

export const {toggleLoader,togglePublish} = loaderSlice.actions
export default loaderSlice.reducer;